import NBType, { InferType } from '@netbase/nb-type'
import AMDomainStatSchema from './AMDomainStatSchema'
import ContentType from '../enums/ContentType'
import FirehoseStatus from '../enums/FirehoseStatus'
import Precision from '../enums/Precision'
import PremiumFeature from '../enums/PremiumFeature'
import Sharing from '../enums/Sharing'
import SharingEditing from '../enums/SharingEditing'
import TimeInterval from '../enums/TimeInterval'
import TopicStatus from '../enums/TopicStatus'
import UserProfileInfoSchema from './UserProfileInfoSchema'

const TopicInfoSchema = NBType.object().shape('TopicInfoSchema', {
  /* @prop */
  accessible: NBType.boolean(),
  /* @prop */
  accountProfileId: NBType.number(),
  /* @prop */
  active: NBType.boolean(),
  /* @prop */
  amDomainStats: NBType.array().of(AMDomainStatSchema).nullable(),
  /* @prop */
  annotated: NBType.boolean(),
  /* @prop */
  annotationEnabled: NBType.boolean(),
  /* @prop */
  archive: NBType.boolean(),
  /* @prop */
  bigBang: NBType.boolean(),
  /* @prop */
  buildProgress: NBType.number(),
  /* @prop */
  contentType: NBType.enum(ContentType),
  /* @prop */
  createDate: NBType.timestamp().nullable(),
  /* @prop */
  cvLogos: NBType.array().of(NBType.string()).nullable(),
  /* @prop */
  dataModelFeatures: NBType.object(),
  /* @prop */
  description: NBType.string().nullable(),
  /* @prop */
  displayImgUrl: NBType.string().nullable(),
  /* @prop */
  downloadProgress: NBType.number(),
  /* @prop */
  fhTwitterHistoryEndDate: NBType.timestamp().nullable(),
  /* @prop */
  fhTwitterHistoryStartDate: NBType.timestamp().nullable(),
  /* @prop */
  fhTwitterStatus: NBType.enum(FirehoseStatus),
  /* @prop */
  fromDate: NBType.timestamp().nullable(),
  /* @prop */
  imgUrl: NBType.string().nullable(),
  /* @prop */
  indexSampleFactor: NBType.number(),
  /* @prop */
  languageFilters: NBType.array().of(NBType.string()).nullable(),
  /* @prop */
  maxDocCount: NBType.number(),
  /* @prop */
  name: NBType.string(),
  /* @prop */
  numGeoFences: NBType.number(),
  /* @prop */
  originatedFromInsightApi: NBType.boolean(),
  /* @prop */
  owner: UserProfileInfoSchema,
  /* @prop */
  premiumFeatures: NBType.array().of(NBType.enum(PremiumFeature)),
  /* @prop */
  reindexingInstall: NBType.boolean(),
  /* @prop */
  sampledGIIndex: NBType.boolean(),
  /* @prop */
  sampledIndex: NBType.boolean(),
  /* @prop */
  scale: NBType.boolean(),
  /* @prop */
  sentimentFocus: NBType.enum(Precision).nullable(),
  /* @prop */
  sharing: NBType.enum(Sharing),
  /* @prop */
  sharingEditing: NBType.enum(SharingEditing),
  /* @prop */
  starRatingNames: NBType.array().of(NBType.string()),
  /* @prop */
  status: NBType.enum(TopicStatus).nullable(),
  /* @prop */
  submittingAnnotation: NBType.boolean(),
  /* @prop */
  surveyScoreNames: NBType.array().of(NBType.string()),
  /* @prop */
  tags: NBType.array().of(NBType.string()).nullable(),
  /* @prop */
  timeInterval: NBType.enum(TimeInterval),
  /* @prop */
  toDate: NBType.timestamp().nullable(),
  /* @prop */
  topicId: NBType.number(),
  /* @prop */
  uniqueAuthor: NBType.number().nullable(),
  /* @prop */
  updateDate: NBType.timestamp().nullable(),
  /* @prop */
  usable: NBType.boolean(),
  /* @prop */
  userProfileId: NBType.number()
  /* END */
})
export default TopicInfoSchema
export type TopicInfo = InferType<typeof TopicInfoSchema>
// RESERVE BELOW
